module.exports = __webpack_public_path__ + "static/img/examine_head.cf74372c.png";